module.exports = __webpack_public_path__ + "static/img/globalpay.c67b521.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/globalpay.gif
// module id = 5Itk
// module chunks = 1